import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Map from '../components/Map';
// import Caption from '../components/Caption';
import SelectTerritory from '../components/SelectTerritory';
import UpdatedAt from '../components/UpdatedAt';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
  },
  mapContainer: {
    position: 'relative',
    // height: 'calc(100% - 64px - 35px)',
    height: 'calc(100% - 35px)',
    width: '100%',
  },
  header: {
    height: '64px',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flexGrow: 1,
    paddingTop: 10,
    paddingBottom: 10,
  },
}));

const AppContainer = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* <header className={classes.header}>
        <Caption />
      </header> */}
      <main className={classes.mapContainer}>
        <Map />
        <SelectTerritory />
      </main>
      <footer className={classes.footer}>
        <UpdatedAt />
      </footer>
    </div>
  );
};

export default AppContainer;
